import React, {Component} from 'react'
import {StatusItem, StatusItemValue, StatusItemClear} from './Status.styles'

import {Icon} from '../../../shared/tr-icons'

class StatusSearchItemContainer extends Component {
    handleRemoveClick = (evt) => {
      evt.preventDefault()

      this.props.handleRemoveSearch()

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Status remove search item',
        type: 'Datatable'
      })
    }

    render() {
      return (
        <StatusItem data-testid='status-sortitem' className={this.props.className}>
          Search
          <StatusItemValue data-testid='status-sortvalue'>: {this.props.search}</StatusItemValue>
          <StatusItemClear onClick={this.handleRemoveClick}>
            <Icon type='clearOutline' baseColor='white' />
          </StatusItemClear>
        </StatusItem>
      )
    }
}

export default StatusSearchItemContainer
